import './Header.scss'
import {useState, useRef, useEffect} from 'react'
import {useOutsideClick} from '../../hooks/useOutsideClick'
import {NavLink, useLocation} from 'react-router-dom'
import {HashLink} from 'react-router-hash-link'

export const Header = ({children}) => {
    return (
        <header className="header">
            {children}
        </header>
    )
}

const PrimaryNavigation = ({ children }) => {
    return (
        <nav className="header-nav-primary">
            <ul className={"nav-links"}>
                {children}
            </ul>
        </nav>
    )
}
Header.PrimaryNavigation = PrimaryNavigation

const SecondaryNavigation = ({ children, displaySize }) => {
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    const ref = useRef()
    useOutsideClick(ref, () => setShowMobileMenu(false))

    const handleOnMenuClick = () => {
        setShowMobileMenu(!showMobileMenu)
    }

    const { pathname } = useLocation()

    useEffect(() => {
        setShowMobileMenu(false)
    }, [pathname])

    const handleOnClick = () => {
        setShowMobileMenu(!showMobileMenu)
    }

    return (
        <nav ref={ref} className="header-nav-secondary" data-display-size={displaySize}>
            {displaySize === 'mobile' &&
                <button aria-label={'Toggle menu'} className={'mobile-menu-btn'} onClick={handleOnMenuClick}>
                    {showMobileMenu ?
                        <span aria-hidden="true" className="material-symbols-outlined">close</span>
                        :
                        <span aria-hidden="true" className="material-symbols-outlined">menu</span>
                    }
                </button>
            }
            {(displaySize === 'desktop' || showMobileMenu) &&
                <ul className={'secondary-nav-links'} onClick={handleOnClick}>
                    {children}
                </ul>
            }
        </nav>
    )
}
Header.SecondaryNavigation = SecondaryNavigation

const HeaderLink = ({ children, link, hashLink, ariaLabel}) => {
    return (
        <li className="nav-link">
            {hashLink ?
                <HashLink
                    id={'header-link-' + hashLink?.split('#')[1]}
                    className={'link'}
                    to={hashLink}
                    aria-label={ariaLabel}
                    title={ariaLabel}
                >
                    {children}
                </HashLink>
            :
                <NavLink
                    id={'header-link-' + link.split('/')[link.split('/').length - 1]}
                    className={({ isActive }) => (isActive ? 'link active' : ' link inactive')}
                    to={link}
                    aria-label={ariaLabel}
                    title={ariaLabel}
                >
                    {children}
                </NavLink>
            }
        </li>
    )
}
Header.Link = HeaderLink